import type { FC } from "react";

import { Icon } from "@/ui/components/primitives/Icon";
import { TextBody } from "@/ui/components/typography/TextBody";
import {
  STEPPER_BADGE_BASE_CLASS,
  STEPPER_BADGE_STATE_CLASS_MAP,
  STEPPER_CONNECTOR_BASE_CLASS,
  STEPPER_CONNECTOR_STATE_CLASS_MAP,
  STEPPER_ICON_CLASS,
  STEPPER_ITEM_CLASS,
  STEPPER_LABEL_BASE_CLASS,
  STEPPER_LABEL_DISABLED_CLASS,
  STEPPER_TYPE_ICON_MAP,
  type TStepperItemProps,
} from "@/ui/components/data-display/Stepper/Stepper.config";
import { cn } from "@/ui/lib/utils";

export const StepperItem: FC<TStepperItemProps> = (
  {
    type,
    label,
    state,
    connector,
    className,
    ...props
  },
) => (
  <li
    {...props}
    data-component="StepperItem"
    data-state={state}
    aria-current={state === "current" ? "step" : undefined}
    className={cn(STEPPER_ITEM_CLASS, className)}
  >
    { connector && (
      <span
        aria-hidden="true"
        data-component="StepperConnector"
        className={cn(STEPPER_CONNECTOR_BASE_CLASS, STEPPER_CONNECTOR_STATE_CLASS_MAP[connector])}
      />
    ) }
    <span className={cn(STEPPER_BADGE_BASE_CLASS, STEPPER_BADGE_STATE_CLASS_MAP[state])}>
      <Icon icon={STEPPER_TYPE_ICON_MAP[type]} className={STEPPER_ICON_CLASS} />
    </span>
    <TextBody
      tag="span"
      size={4}
      align="center"
      isResponsive={false}
      className={cn(STEPPER_LABEL_BASE_CLASS, state === "disabled" && STEPPER_LABEL_DISABLED_CLASS)}
      weight={state === "disabled" ? "normal" : "bold" }
    >
      { label }
    </TextBody>
  </li>
);

StepperItem.displayName = "StepperItem";
